/** @format */
import dynamic from "next/dynamic";
import { Layout } from "../../components/common/Layout";
const ConsciousStore = dynamic(() =>
  import("../../components/UnlayerTemplates/ConsciousStore")
);
import { useEffect } from 'react';


export default function ConsciousStorePage() {
  const meta = {
    title: "Shop curated trends at Qalara wholesale marketplace ",
    description:
      "A curated wholesale e-store for Indian products",
    keywords:
      "Curated, trends, values, categories, wholesale, bulk, ready-to-ship, custom, fashion, accessories, homedecor, furniture, rugs, kitchen, dining, linen, furnishings, artisanal, organic, sustainable, ecofriendly India, Southeast asia, carving, inlay, basketry, weaving, metal, global, exports, imports, vendors, suppliers",
    url: "/explore/Conscious-store/",
  };
  useEffect(() => {
    const handlePopState = () => {
      window.location.reload(); // Ensures the correct page loads
    };
  
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return (
    <Layout meta={meta}>
      <ConsciousStore />
    </Layout>
  );
}
